<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button autoHide="false"></ion-menu-button>
      <ion-back-button defaultHref="/call/dashboard" text="" icon="chevron-back"></ion-back-button>
    </ion-buttons>
    <ion-title>{{getPageTitleByClaim()}}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-margin-top">
  <div class="container">
    <div class="header">
      <div class="small">
        This week ({{earningsTotais.semanaAtualRestaurante.label}})
      </div>
      <section
        class="card-atention"
        *ngIf="claim === this.userType.Caller || claim === this.userType.Driver"
      >
        <h1 class="title">
          $ {{(earningsTotais.semanaAtualRestaurante ?
          earningsTotais.semanaAtualRestaurante.totalRecebido : 0) +
          (earningsTotais.semanaAtualCorrida ?
          earningsTotais.semanaAtualCorrida.saldoSemanal : 0)}}
          <span>(Total)</span>
        </h1>
        <div class="withdraw-row">
          <span class="available">Available to withdraw: <strong>${{ availableBalance | number:'1.2-2' }}</strong></span>
          <ion-button size="small" fill="solid" color="primary" (click)="openWithdrawalModal()">
            <ion-icon name="cash-outline" slot="start"></ion-icon>
            Withdraw
          </ion-button>
        </div>
      </section>
      <section class="card-atention" *ngIf="claim === this.userType.Restaurant">
        <h1 class="title">
          $ {{(earningsTotais.semanaAtualRestaurante ?
          earningsTotais.semanaAtualRestaurante.valorTransferir : 0)}}
          <span>Total amount transferable to GoSpread</span>
        </h1>
      </section>
      <section
        class="card-atention card-atention-alternate2"
        *ngIf="claim === this.userType.Driver"
      >
        <div class="small" style="color: #b10e0e">Trip Fee Due</div>
        <h1 class="title" style="color: #b10e0e">
          $ {{earningsTotais.semanaAtualCorrida.saldoEmAberto}}
        </h1>
        <ion-button class="ion-margin-top f" size="small" (click)="payRaces()"
          >Pay Now</ion-button
        >
      </section>
      <section
        class="card-atention card-atention-alternate2"
        *ngIf="claim === this.userType.Restaurant"
      >
        <ion-button
          class="ion-margin-top f"
          size="small"
          (click)="payServices()"
          >Pay Now</ion-button
        >
      </section>
      <div class="small" *ngIf="claim === this.userType.Caller">Bonus</div>
      <h1 class="title" *ngIf="claim === this.userType.Caller">
        $ {{earningsTotais.semanaAtualCorrida ?
        earningsTotais.semanaAtualCorrida.saldoBonusSemanal : 0}}
      </h1>
    </div>
  </div>
  <swiper-container
    [pager]="true"
    [slidesPerView]="1"
    [modules]="swiperModules"
  >
    <swiper-slide
      *ngIf="claim === this.userType.Caller || claim === this.userType.Restaurant"
    >
      <section class="container-informations">
        <ion-grid>
          <h3 class="title">
            {{claim === this.userType.Caller ? 'Services' : 'Details'}}
          </h3>
          <ion-row>
            <ion-col size="2.2" *ngIf="claim === this.userType.Caller">
              <div>
                <p>
                  <strong
                    >{{earningsTotais.semanaAtualRestaurante.totalRecebido |
                    currency}}</strong
                  >
                </p>
                <p>Balance</p>
              </div>
            </ion-col>
            <!-- <ion-col size="2.2" *ngIf="claim === this.userType.Restaurant">
                <div>
                  <p>
                    <strong
                      >{{earningsTotais.semanaAtualRestaurante.valorTransferir | currency}}</strong
                    >
                  </p>
                  <p>Pay</p>
                </div>
              </ion-col> -->
            <ion-col size="3">
              <div>
                <p>
                  <strong
                    >{{earningsTotais.semanaAtualRestaurante.reservas}}</strong
                  >
                </p>
                <p>Services</p>
              </div>
            </ion-col>
            <ion-col size="{{claim === this.userType.Restaurant ? 3.0 : 2.5}}">
              <div>
                <p>
                  <strong
                    >{{earningsTotais.semanaAtualRestaurante.numeroPessoas}}</strong
                  >
                </p>
                <p>N° People</p>
              </div>
            </ion-col>
            <ion-col size="{{claim === this.userType.Restaurant ? 2.0 : 1.5}}">
              <div>
                <p>
                  <strong
                    >{{earningsTotais.semanaAtualRestaurante.finalizados}}</strong
                  >
                </p>
                <p>Done</p>
              </div>
            </ion-col>
            <ion-col size="2.8">
              <div>
                <p>
                  <strong
                    >{{earningsTotais.semanaAtualRestaurante.recusados}}</strong
                  >
                </p>
                <p>Declined</p>
              </div>
            </ion-col>
            <!-- <ion-col size="2">
                <div>
                  <p>
                    <strong
                      >{{earningsTotais.semanaAtualRestaurante.recusados}}</strong
                    >
                  </p>
                  <p>Refused</p>
                </div>
              </ion-col> -->
          </ion-row>
        </ion-grid>
      </section>
    </swiper-slide>
    <swiper-slide
      *ngIf="claim === this.userType.Caller || claim === this.userType.Driver"
    >
      <section class="container-informations">
        <ion-grid>
          <h3 class="title">
            {{claim === this.userType.Caller ? 'Trips' : 'Details'}}
          </h3>
          <ion-row>
            <ion-col size="3" *ngIf="claim === this.userType.Caller">
              <div>
                <p>
                  <strong
                    >{{earningsTotais.semanaAtualCorrida.saldoSemanal |
                    currency}}</strong
                  >
                </p>
                <p>Balance</p>
              </div>
            </ion-col>
            <ion-col size="3" *ngIf="claim === this.userType.Driver">
              <div>
                <p>
                  <strong
                    >{{earningsTotais.semanaAtualCorrida.saldoTotal |
                    currency}}</strong
                  >
                </p>
                <p>Lifetime</p>
              </div>
            </ion-col>
            <ion-col size="3">
              <div>
                <p>
                  <strong
                    >{{earningsTotais.semanaAtualCorrida.corridasSemana}}</strong
                  >
                </p>
                <p>Total Trips</p>
              </div>
            </ion-col>
            <ion-col size="3">
              <div>
                <p>
                  <strong
                    >{{earningsTotais.semanaAtualCorrida.corridasFinalizadasSemana}}</strong
                  >
                </p>
                <p>Done</p>
              </div>
            </ion-col>
            <ion-col size="3">
              <div>
                <p>
                  <strong
                    >{{earningsTotais.semanaAtualCorrida.corridasCanceladasSemana}}</strong
                  >
                </p>
                <p>Cancelled</p>
              </div>
            </ion-col>
          </ion-row>
        </ion-grid>
      </section>
    </swiper-slide>
  </swiper-container>
  <div class="container" style="margin-top: 0">
    <div class="header">
      <div
        class="small"
        *ngIf="claim === this.userType.Driver"
        style="margin: 0"
      >
        You are clear until {{ earningsTotais.semanaAtualCorrida.terminoData |
        date: "MM/dd/yyyy" }}
      </div>
    </div>
    <section
      class="card-atention card-atention-alternate2"
      *ngIf="claim === this.userType.Driver"
    >
      <div class="small" style="color: #1a2d55">Weekly Access Fee</div>
      <h1 class="title" style="color: #1a2d55; font-size: 1.2rem">
        $ Free (Promotion)
      </h1>
      <!-- <ion-button class="ion-margin-top f" size="small" (click)="payPlatform()">Pay Now</ion-button> -->
    </section>
    <section class="card-list">
      <div *ngFor="let periodo of earningsTotais.periodos">
        <h3 class="title">{{periodo.labelMes}}</h3>
        <ul class="list" *ngFor="let dadosMes of periodo.data">
          <li>
            {{dadosMes.label}}
            <strong>$ {{dadosMes.valor}}</strong>
          </li>
        </ul>
      </div>
    </section>
  </div>
</ion-content>
